<template>
    <!-- 码头箱动态 -->
    <div class="dynamics">
          <div class="dynamics_bt">
            <Animation class="biaoti" :message="mtx_parentMessage" />
            <!-- <div>
                <p  class="dynamics_left">码头箱动态</p>
                <p>全国主要口岸码头箱动态查询</p>
            </div> -->
            
          </div>
          <!-- 内容 -->
          <div class="dynamics-con">
            <!-- 循环 -->
            <div class="dynamics-son" v-for="(item,index) in dockContainerList.slice(0,3)" :key="index">
              <div class="leftimg">
                <img :src="item.logo" alt="">
                <span>{{item.name_cn+' '+item.name_en}}</span>
              </div>
              <div class="centerNr">
                <a class="haizi" v-for="(it,idx) in item.showchild" :key="idx" :href="it.url" target="_blank">
                  <div class="xian"></div>
                  <div class="neir">
                    <div class="nr-logo">
                      <img :src="it.logo" alt="">
                    </div>
                    <div class="nr-name">
                      {{it.title}}
                    </div>
                    <div class="nr-con">{{it.content}}</div>
                  </div>
                </a>
              </div>
              <div v-show="item.showchild.length>0" class="rightimg">
                <!-- <div @click="backData(item)" class="icom" :class="{'icomer' : item.left}">
                  <i class="el-icon-arrow-left iconn"></i>
                </div>
                <div @click="nextData(item)" class="icom" :class="{'icomer' : item.right}">
                  <i class="el-icon-arrow-right iconn"></i>
                </div> -->
                <el-button @click="backData(item)" :disabled="!item.left" class="icom" :class="{'icomer' : item.left}" icon="el-icon-arrow-left" circle></el-button>
                <el-button @click="nextData(item)" :disabled="!item.right" class="icom" :class="{'icomer' : item.right}" icon="el-icon-arrow-right" circle></el-button>
              </div>
            </div>
          </div>

          <div class="dynamics_right">
              <div class="button" @click="chaKan">
                  <span>
                    去查看
                  </span>
                  <img src="../../assets/images/hpcopy/chakan.png" />
              </div>
          </div>
        </div>
</template>

<script>
import Animation from './AnimationPage.vue';
import { validList } from "@/api/api";
export default {
    components:{
        Animation,
    },
    data(){
        return{
            // 标题
            mtx_parentMessage:{
                title:'码头箱动态',
                content:'全国主要口岸码头箱动态查询'
            },
            // 码头箱列表数据
            MaTouXiangList:[],
            dockContainerList:[],
        }
    },
    methods:{
      // 码头箱动态
      async getValidList() {
        const res = await validList();
        if (res.code == 1) {
          this.MaTouXiangList = res.data;
          this.dockContainerList = res.data;

          for (let i = 0; i < this.dockContainerList.length; i++) {
            this.dockContainerList[i].dc_id = i //id
            let haizi = this.dockContainerList[i].dynamics
            this.dockContainerList[i].page_no=1 //页码
            this.dockContainerList[i].total=haizi.length //总长度
            this.dockContainerList[i].left=false //左侧按钮是否可以点击
            this.dockContainerList[i].right=false //右侧按钮是否可以点击
            this.dockContainerList[i].showchild=[] // 展示的数据

            if(haizi.length>2){
              this.dockContainerList[i].showchild = [haizi[0],haizi[1]]
              this.dockContainerList[i].right=true
            }else if(haizi.length==2){
              this.dockContainerList[i].showchild = [haizi[0],haizi[1]]
            }else if(haizi.length==1){
              this.dockContainerList[i].showchild = [haizi[0]]
            }else{
              this.dockContainerList[i].showchild = []
            }
          }
        }
      },
      chaKan(){
        this.$router.push({
          name:'Tool',
          params:{
            menuInx:'1',
          }
        })
      },
      // 切换数据
      // 下一页
      nextData(e){
        let index = e.dc_id
        let haizi = this.dockContainerList[index]
        haizi.page_no += 1
        haizi.left = true
        if(haizi.total <= Number(haizi.page_no)*2){
          haizi.right = false
          if(haizi.total == Number(haizi.page_no)*2){
            haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2],haizi.dynamics[Number(haizi.page_no)*2-1]]
          }else{
            haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2]]
          }
        }else{
          haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2],haizi.dynamics[Number(haizi.page_no)*2-1]]
        }
        this.dockContainerList[index] = haizi
        this.dockContainerList=[...this.dockContainerList]
      },
      // // 上一页
      backData(e){
        let index = e.dc_id
        let haizi = this.dockContainerList[index]

        haizi.page_no -= 1
        haizi.left = true
        haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2],haizi.dynamics[Number(haizi.page_no)*2-1]]
        haizi.right = true
        if(haizi.page_no==1){
          haizi.left = false
        }else{
          haizi.left = true
        }
        this.dockContainerList[index] = haizi
        this.dockContainerList=[...this.dockContainerList]
      }
    },
    mounted(){
      this.getValidList()
    },
    computed:{

    },
    beforeDestroy() {
        
    },
}
</script>

<style lang="scss" scoped>
// 版心
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}

.dynamics{
  background-image:url('../../assets/images/hpcopy/mtxDtBj.png');	
  background-repeat: no-repeat;
  background-size:100% 100%;
  padding-bottom: 150px;
  .dynamics_bt{
    padding-top: 68px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #999999;
    line-height: 28px;
    font-style: normal;
    text-transform: none;
    .dynamics_left{
        font-size: 32px;
        color: #000000;
        line-height: 38px;
    }
  }

  .biaoti{
    text-align: center;
    width: 100%;
  }
  .dynamics_right{
    width: 100%;
    cursor: pointer;
    margin: auto;
    display: flex;
    justify-content: center;
    .button{
      width: 200px;
      height: 44px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #2E3655;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        font-size: 14px;
        color: #2E3655;
        line-height: 44px;
      }
      img{
        width: 14px;
        height: 14px;
        margin-left: 6px;
      }
    }
  }
}

.dynamics-con{
  // background: pink;
  .dynamics-son{
    width: 1608px;
    height: 151px;
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.06);
    border-radius: 6px 6px 6px 6px;
    margin: 0 auto 52px;

    display: flex;
    align-items: center;
    .leftimg{
      width: 442px;
      position: relative;
      img{
        width: 314px;
        height: 126px;
        margin-top: 25px;
      }
      span{
        font-weight: 600;
        font-size: 28px;
        color: #2E3655;
        position: absolute;
        top: 56px;
        left: 136px;
      }
    }

    .centerNr{
      display: flex;
      align-items: center;
      width: 1048px;
      .xian{
        width: 0px;
        height: 51px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #EDEBEB;
        margin-right: 70px;
      }
      .haizi{
        width: 524px;
        display: flex;
        align-items: center;
        text-decoration: none;
        .nr-logo{
          img{
            height: 40px;
          }
        }

        .nr-name{
          font-weight: 500;
          font-size: 14px;
          color: #2E3655;
          width: 384px;
          line-height: 20px;
          overflow: hidden; /* 隐藏超出部分 */
          white-space: nowrap; /* 不换行 */
          text-overflow: ellipsis; /* 超出部分显示为省略号 */
        }

        .nr-con{
          font-weight: 400;
          font-size: 12px;
          color: #787E93;
          width: 384px;
          line-height: 18px;
          overflow: hidden; /* 隐藏超出部分 */
          white-space: nowrap; /* 不换行 */
          text-overflow: ellipsis; /* 超出部分显示为省略号 */
        }
      }
    }

    .rightimg{
      width: 114px;
      // height: 100%;
      display: flex;
      .icom{
        width: 28px;
        height: 28px;
        margin-right: 20px;
        // cursor: pointer;
        border: #D3D3D3 1px solid;
        color: #D3D3D3;
        border-radius: 2px  2px  2px  2px;
        background: #fff;
        display: flex;
        align-items: center; 
        justify-content: center;       
      }

      .icomer:hover{
        border: #064FAF 1px solid;
        color: #064FAF;
      }

      .icomer{
        border: #D3D3D3 1px solid;
        color: #4E4949;
      }
    }
  }
}

.flex {
  display: flex;
}
</style>